"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoPositionFromLatLngString = exports.GeoPositionFromLatLng = exports.LatLngFromString = exports.LatLngTemplateLiteral = exports.LatLng = exports.ApiKey = exports.BASE_URL = void 0;
exports.makeApiKeyConfig = makeApiKeyConfig;
const effect_1 = require("effect");
const geography_1 = require("../geography");
const NAMESPACE = 'Google.Common';
exports.BASE_URL = 'https://www.googleapis.com';
exports.ApiKey = effect_1.Schema.String.pipe(
/*
 * Google API keys are 39 characters long and drawn from the base64url
 * alphabet, so hyphens and underscores are as legitimate as alphanumerics.
 * Rejecting them made a correctly provisioned key indistinguishable from a
 * missing one (IOTPE-1917).
 */
effect_1.Schema.pattern(/^[A-Za-z\d_-]{39}$/), effect_1.Schema.brand('GoogleApiKey')).annotations({
    identifier: `${NAMESPACE}.ApiKey`,
    description: 'A 39 character base64url string',
});
function makeApiKeyConfig(name) {
    return effect_1.Schema.Config(name, exports.ApiKey);
}
exports.LatLng = effect_1.Schema.Struct({
    lat: geography_1.Latitude,
    lng: geography_1.Longitude,
}).annotations({
    identifier: `${NAMESPACE}.LatLng`,
    description: 'Google data format equivalent for `GeoPosition`',
    pretty: () => ({ lat, lng }) => `(${lat.toFixed(6)}, ${lng.toFixed(6)})`,
});
exports.LatLngTemplateLiteral = effect_1.Schema.TemplateLiteralParser(geography_1.Latitude, ',', geography_1.Longitude).annotations({
    identifier: `${NAMESPACE}.LatLngTemplateLiteral`,
    description: 'String containing latitude and longitude separated by a comma',
});
exports.LatLngFromString = (0, effect_1.pipe)(exports.LatLngTemplateLiteral, effect_1.Schema.transform(exports.LatLng, {
    strict: true,
    decode: ([lat, _, lng]) => ({ lat, lng }),
    encode: ({ lat, lng }) => [lat, ',', lng],
})).annotations({
    identifier: `${NAMESPACE}.LatLngFromString`,
});
exports.GeoPositionFromLatLng = effect_1.Schema.transform(exports.LatLng, geography_1.GeoPosition, {
    strict: true,
    decode: ({ lat, lng }) => geography_1.GeoPosition.make({ lat, lon: lng }),
    encode: ({ lat, lon }) => exports.LatLng.make({ lat, lng: lon }),
}).annotations({
    identifier: `${NAMESPACE}.GeoPositionFromLatLng`,
});
exports.GeoPositionFromLatLngString = (0, effect_1.pipe)(exports.LatLngFromString, effect_1.Schema.compose(exports.GeoPositionFromLatLng)).annotations({
    identifier: `${NAMESPACE}.GeoPositionFromLatLngString`,
});
//# sourceMappingURL=common.js.map